import React, { FC, useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import './header-activity.scss';

const DEFAULT_DELAY_MS = 200;

interface Props {
    loading: boolean;
    /** true — первый mount, данных ещё нет */
    initial?: boolean;
    delayMs?: number;
}

const HeaderActivity: FC<Props> = (props: Props) => {
    const { loading, initial = false, delayMs = DEFAULT_DELAY_MS } = props;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!loading) {
            setVisible(false);
            return undefined;
        }

        const timer = setTimeout(() => setVisible(true), delayMs);
        return () => clearTimeout(timer);
    }, [loading, delayMs]);

    if (!visible) {
        return null;
    }

    return (
        <div className="header-activity" role="status" aria-live="polite">
            <LoadingOutlined className="header-activity-icon" spin />
            <span className="header-activity-label">{initial ? 'Загрузка…' : 'Обновление…'}</span>
        </div>
    );
};

export default HeaderActivity;
